import { z } from "zod";

export const myFilesSearchSchema = z.object({
  brandId: z.union([z.number(), z.literal("unknown")]).optional(),
  folder: z.preprocess(
    (val) =>
      ["archive", "sourcefiles", "trash"].includes(val as string) ? val : null,
    z
      .enum(["sourcefiles", "archive", "trash"])
      .nullable()
      .optional()
      .transform((v) => v ?? undefined),
  ),
  folderPath: z.string().optional(),
  openUpload: z.boolean().optional(),
  projectId: z.number().optional(),
  requestId: z.number().optional(),
  requestType: z.enum(["graphic", "video", "website"]).optional(),
});

export type MyFilesSearchSchema = z.infer<typeof myFilesSearchSchema>;
